"use strict";

exports.__esModule = true;
exports.destroyCookie = destroyCookie;
exports.getCookie = getCookie;
exports.setCookie = setCookie;

/**
 * Fetches a cookie from the browser
 *
 * @export
 * @param {*} name
 * @returns
 */
function getCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  const len = ca.length;
  let c; // eslint-disable-next-line no-plusplus

  for (let i = 0; i < len; i++) {
    c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }

    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }

  return null;
}
/**
 * Sets a cookie to the browser
 *
 * @export
 * @param {*} name
 * @param {*} value
 * @param {*} days
 * @param {*} path
 * @param {*} domain
 */


function setCookie(name, value, days, path, domain) {
  let expires = '';

  if (!path) {
    path = '/';
  }

  if (!domain) {
    domain = '';
  }

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${name}=${value}${expires}; path=${path}${domain ? `;domain=${domain}` : ''}`;
}
/**
 * Removes a cookie from the browser
 *
 * @export
 * @param {*} name
 */


function destroyCookie(name) {
  setCookie(name, null, -1);
}